export default __webpack_public_path__ + "static/media/dragon.ce91cd36.png";